import { createContext } from 'react';
import { User } from '../auth/type';

interface AuthContext {
    user: User | string | null;
    setUser: (user: User | null) => void;
    isLoading: boolean;
    isProgress: boolean;
    progressType: boolean;
    randomId: string;
    demandStatus: string;
    setDemandStatus: (demandStatus: string) => void;
    setProgressType: (progressType: boolean) => void;
    setLoader: (isLoading: boolean) => void;
    setRandomId: (randomId: string) => void;
    setProgress: (isProgress: boolean) => void;
    setShowLogout: (showLogout: boolean) => void;
    showLogout: boolean;
}

export const AuthContext = createContext<AuthContext>({
    user: localStorage.getItem('user'), // Default value
    setUser: () => {
        '';
    },
    demandStatus: '',
    progressType: true,
    randomId: '',
    isProgress: true,
    isLoading: false,
    showLogout: false,
    setProgress: () => {},
    setLoader: () => {},
    setRandomId: () => {},
    setDemandStatus: () => {},
    setProgressType: () => {},
    setShowLogout: () => {},
});
